import { useState, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDownload,
    faCar,
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import './creta.css';
/**** Fotos Banner ****/
import Slider1 from "../../images/modelos/nuevocreta/banner/creta-banner-1.webp";
import Slider2 from "../../images/modelos/nuevocreta/banner/creta-banner-2.webp";
import Slider3 from "../../images/modelos/nuevocreta/banner/creta-banner-3.webp";
import Slider4 from "../../images/modelos/nuevocreta/banner/creta-banner-4.webp";
import Slider5 from "../../images/modelos/nuevocreta/banner/creta-banner-5.webp";
/****Fotos calidad de tiempo ****/
import Banner from "../../images/modelos/nuevocreta/calidad/creta-banner.webp";
import Productividad from "../../images/modelos/nuevocreta/calidad/creta-productividad.webp";
import Asiento from "../../images/modelos/nuevocreta/calidad/creta-asiento.webp";
import Galeria1 from "../../images/modelos/nuevocreta/galeria/creta-galeria-1.webp";
import Galeria2 from "../../images/modelos/nuevocreta/galeria/creta-galeria-2.webp";
import Galeria3 from "../../images/modelos/nuevocreta/galeria/creta-galeria-3.webp";
import Galeria4 from "../../images/modelos/nuevocreta/galeria/creta-galeria-4.webp";
import Galeria5 from "../../images/modelos/nuevocreta/galeria/creta-galeria-5.webp";
import Galeria6 from "../../images/modelos/nuevocreta/galeria/creta-galeria-6.webp";
import Galeria7 from "../../images/modelos/nuevocreta/galeria/creta-galeria-7.webp";
import Galeria8 from "../../images/modelos/nuevocreta/galeria/creta-galeria-8.webp";
/****Fotos disenio ****/
import Interior from "../../images/modelos/nuevocreta/disenio/creta-interior.webp";
import CretaExtBanner from "../../images/modelos/nuevocreta/disenio/creta-banner-exterior.webp";
import CretaExt1 from "../../images/modelos/nuevocreta/disenio/creta_exterior_1.webp";
import CretaExt2 from "../../images/modelos/nuevocreta/disenio/creta_exterior_2.webp";
import CretaExt3 from "../../images/modelos/nuevocreta/disenio/creta_exterior_3.webp";
import CretaExt4 from "../../images/modelos/nuevocreta/disenio/creta_exterior_4.webp";
import CretaExt5 from "../../images/modelos/nuevocreta/disenio/creta_exterior_5.webp";
import CretaExt6 from "../../images/modelos/nuevocreta/disenio/creta_exterior_6.webp";
import CretaInt1 from "../../images/modelos/nuevocreta/disenio/creta-interior-1.webp";
import CretaInt2 from "../../images/modelos/nuevocreta/disenio/creta-interior-2.webp";
import CretaInt3 from "../../images/modelos/nuevocreta/disenio/creta-interior-3.webp";
import CretaInt4 from "../../images/modelos/nuevocreta/disenio/creta-interior-4.webp";
import CretaInt5 from "../../images/modelos/nuevocreta/disenio/creta-interior-5.webp";
import CretaInt6 from "../../images/modelos/nuevocreta/disenio/creta-interior-6.webp";
/****Fotos rendimiento ****/
import Motor from "../../images/modelos/nuevocreta/rendimiento/creta-motor.webp";
import Manual from "../../images/modelos/nuevocreta/rendimiento/creta-manual.webp";
import ModoConduccion from "../../images/modelos/nuevocreta/rendimiento/modo-conduccion.webp";
import RendimientoBanner from "../../images/modelos/nuevocreta/rendimiento/creta-rendimiento-banner.webp";
/****Fotos seguridad ****/
import Seguridad1 from "../../images/modelos/nuevocreta/seguridad/creta-seguridad-1.webp";
import Seguridad2 from "../../images/modelos/nuevocreta/seguridad/creta-seguridad-2.webp";
import Seguridad3 from "../../images/modelos/nuevocreta/seguridad/creta-seguridad-3.webp";
import Seguridad4 from "../../images/modelos/nuevocreta/seguridad/creta-seguridad-4.webp";
import Seguridad5 from "../../images/modelos/nuevocreta/seguridad/creta-seguridad-5.webp";
import Seguridad6 from "../../images/modelos/nuevocreta/seguridad/creta-seguridad-6.webp";
/****Fotos conveniencia ****/
import Conveniencia1 from "../../images/modelos/nuevocreta/conveniencia/creta-conveniencia-1.webp";
import Conveniencia2 from "../../images/modelos/nuevocreta/conveniencia/creta-conveniencia-2.webp";
import Conveniencia3 from "../../images/modelos/nuevocreta/conveniencia/creta-conveniencia-3.webp";
import Conveniencia4 from "../../images/modelos/nuevocreta/conveniencia/creta-conveniencia-4.webp";
import Conveniencia5 from "../../images/modelos/nuevocreta/conveniencia/creta-conveniencia-5.webp";
import Conveniencia6 from "../../images/modelos/nuevocreta/conveniencia/creta-conveniencia-6.webp";
/****Ficha técnica ****/
import CretaCatalogo from "../../fichas/nuevo-creta-brochure.pdf";
/***showroom virtual */
import showroom from "../../images/showroom/creta.png";

function InfoNuevoCreta() {
    const [gallerySwiper, getGallerySwiper] = useState(null);
    const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
    const gallerySwiperParams = {
        getSwiper: getGallerySwiper,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    };

    const thumbnailSwiperParams = {
        getSwiper: getThumbnailSwiper,
        slidesPerView: 5,
        loop: true,
        freeMode: true,
        loopedSlides: 5, //looped slides should be the same
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: true,
    };

    useEffect(() => {
        if (
            gallerySwiper !== null &&
            gallerySwiper.controller &&
            thumbnailSwiper !== null &&
            thumbnailSwiper.controller
        ) {
            gallerySwiper.controller.control = thumbnailSwiper;
            thumbnailSwiper.controller.control = gallerySwiper;
        }
    }, [gallerySwiper, thumbnailSwiper]);

    const onChangeMenu = (menu) => {
        switch (menu) {
            case "calidad":
                document.getElementById("tab-calidad").className = "color-hover";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-block";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider1;
                break;
            case "disenio":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-hover";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-block";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider2;
                break;
            case "rendimiento":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-hover";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-block";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider3;
                break;
            case "seguridad":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-hover";
                document.getElementById("tab-conveniencia").className = "color-normal";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-block";
                document.getElementById("conveniencia").className = "d-none";
                document.getElementById("img-carrusel").src = Slider4;
                break;
            case "conveniencia":
                document.getElementById("tab-calidad").className = "color-normal";
                document.getElementById("tab-disenio").className = "color-normal";
                document.getElementById("tab-rendimiento").className = "color-normal";
                document.getElementById("tab-seguridad").className = "color-normal";
                document.getElementById("tab-conveniencia").className = "color-hover";
                document.getElementById("calidad").className = "d-none";
                document.getElementById("disenio").className = "d-none";
                document.getElementById("rendimiento").className = "d-none";
                document.getElementById("seguridad").className = "d-none";
                document.getElementById("conveniencia").className = "d-block";
                document.getElementById("img-carrusel").src = Slider5;
                break;
            default:
                break;
        }
    };

    return (
        <Fragment>
            <link rel="preload" as="image" href={Slider1} />
            <link rel="preload" as="image" href={Banner} />
            <link rel="preload" as="image" href={Productividad} />
            <link rel="preload" as="image" href={Asiento} />
            <link rel="preload" as="image" href={Galeria1} />
            <link rel="preload" as="image" href={Galeria2} />
            <link rel="preload" as="image" href={Galeria3} />
            <link rel="preload" as="image" href={Galeria4} />
            <Container fluid={true}>
                <Row>
                    <Col md={12} className="px-0">
                        <div className="creta-banner-container" >
                            <Image
                                src={Slider1}
                                alt="Creta Banner"
                                className="banner"
                                id="img-carrusel"
                                fluid
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="menu-vehiculo sticky-top">
                <Container>
                    <Row className="py-2 py-md-4">
                        <Col xs={2} md={2} className="my-auto d-none d-sm-block">
                            <h1 className="menu-modelo">CRETA</h1>
                        </Col>
                        <Col
                            xs={12}
                            md={6}
                            className="my-auto vehiculo-item text-md-center px-0"
                        >
                            <ul className="my-auto p-0 m-0">
                                <li
                                    id="tab-calidad"
                                    onClick={() => onChangeMenu("calidad")}
                                    className="color-hover"
                                >
                                    Calidad de tiempo
                                </li>
                                <li
                                    id="tab-disenio"
                                    onClick={() => onChangeMenu("disenio")}
                                    className="color-normal"
                                >
                                    Diseño
                                </li>
                                <li
                                    id="tab-rendimiento"
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="color-normal"
                                >
                                    Rendimiento
                                </li>
                                <li
                                    id="tab-seguridad"
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="color-normal"
                                >
                                    Seguridad
                                </li>
                                <li
                                    id="tab-conveniencia"
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="color-normal"
                                >
                                    Conveniencia
                                </li>
                            </ul>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra">
                            <a
                                href="static/media/nuevo-creta-ficha-tecnica.67fb053c.pdf"
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Ficha</span>
                            </a>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <a
                                href={CretaCatalogo}
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Catálogo</span>
                            </a>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <Link
                                to="/cotizador/nuevo-creta"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra"> Cotizar</span>
                            </Link>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <Link
                                to="/test-drive/nuevo-creta"
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra"> Test Drive</span>
                            </Link>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/***************************************** calidad ***************************************/}
            <section id="calidad">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">
                                NUEVO CRETA
                            </h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                El Nuevo Creta es el SUV urbano que te invita a tomar el control.
                                Con líneas audaces, una parrilla imponente, faros LED de última
                                generación y luces traseras conectadas, proyecta estilo y
                                seguridad en cada ángulo.
                                Un diseño renovado que refleja tu personalidad y te da la confianza
                                de ser protagonista en cada trayecto.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} className="bg-black py-2 px-2 py-md-4 px-md-0 mb-md-3">
                            <Image src={Banner} alt="Creta Banner" className="img-fluid1" fluid />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto order-2 order-md-1">
                                <h3 className="specs-subtitle mt-4 mb-3 pt-2 px-3 px-md-0">
                                    Diseño renovado y presencia única.
                                </h3>
                                <p className="specs-text px-3 px-md-0 mb-0">
                                    Parrilla paramétrica, faros LED de cuatro haces, luces traseras LED conectadas.
                                </p>
                                {/*<p className="specs-text px-3 px-md-0">
                                    Un objeto de arte. Un juguete tecnológico.
                                </p>*/}
                            </Col>
                            <Col md={6} className="my-auto order-1 order-md-2">
                                <Image src={Productividad} alt="Creta productividad" className="img-fluid2" fluid />
                            </Col>
                        </Row>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="my-auto">
                                <Image src={Asiento} alt="Creta asiento" className="img-fluid2" fluid />
                            </Col>
                            <Col md={6} className="my-auto">
                                <h3 className="specs-subtitle mt-4 mb-3 pt-2 px-3 px-md-0">
                                    Tecnología y seguridad de última generación.
                                </h3>
                                <p className="specs-text px-3 px-md-0">
                                    6 airbags, pantalla táctil de 9”, conectividad
                                    total con Apple CarPlay / Android Auto.
                                </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="py-3 py-md-5">
                        <Col md={12} className="text-center">
                            <h2 className="galeria-titulo my-3 pb-2 pb-md-4">Galería</h2>
                            <div>
                                <Swiper {...gallerySwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            alt="Creta Slider1"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria2}
                                            alt="Creta Slider2"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            alt="Creta Slider3"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            alt="Creta Slider4"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            alt="Creta Slider5"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria6}
                                            alt="Creta Slider6"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria7}
                                            alt="Creta Slider7"
                                            className="galeria1"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria8}
                                            alt="Creta Slider8"
                                            className="galeria1"
                                        />
                                    </div>
                                </Swiper>
                                <Swiper {...thumbnailSwiperParams}>
                                    <div>
                                        <Image
                                            src={Galeria1}
                                            alt="Creta Slider1"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria2}
                                            alt="Creta Slider2"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria3}
                                            alt="Creta Slider3"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria4}
                                            alt="Creta Slider4"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria5}
                                            alt="Creta Slider5"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria6}
                                            alt="Creta Slider6"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria7}
                                            alt="Creta Slider7"
                                            className="galeria2"
                                        />
                                    </div>
                                    <div>
                                        <Image
                                            src={Galeria8}
                                            alt="Creta Slider8"
                                            className="galeria2"
                                        />
                                    </div>
                                </Swiper>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6}></Col>
                            <Col xs={6} md={6} className="text-right">
                                <h4
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    Diseño
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </h4>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** disenio ***************************************/}
            <section id="disenio" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">UN SUV ROBUSTO</h2>
                            <p className="model-text mt-3 px-3 px-md-0">
                                El Nuevo Creta transmite confianza desde el primer momento. Su presencia
                                no se impone con exageración, sino con equilibrio. Cada línea y proporción
                                está pensada para proyectar estabilidad, fuerza y una actitud lista para
                                moverse en cualquier dirección.
                                Diseñado para destacar sin esfuerzo, este SUV encuentra el punto exacto
                                entre lo funcional y lo emocional. Su postura elevada, la armonía entre
                                volumen y forma, y una estética limpia pero firme lo convierten en el aliado
                                perfecto para quienes quieren avanzar con seguridad.
                                Porque tomar el control también es elegir un diseño que hable por ti, sin
                                tener que decir una palabra.
                            </p>
                        </Col>
                    </Row>
                </Container>
                
                <Container style={{ minHeight: '300px' }} className="cotizador pb-5">
                    <a href="https://my.matterport.com/show/?m=oFQHjVkM8XL" target="_blank" rel="noopener noreferrer">
                        <center>
                            <Image src={showroom} alt="Showroom Virtual Creta" fluid width={700} height={350} />
                        </center>
                    </a>
                </Container>
            
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={12} className="text-center">
                                <h2 className="specs-subtitle mt-4 pb-3 px-3 px-md-0">
                                    Estilo exterior
                                </h2>
                                <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                    El Nuevo Creta tiene presencia, y se nota. Su frente
                                    renovado, con parrilla paramétrica en cromo negro y
                                    faros LED de cuatro haces, impone carácter desde el
                                    primer vistazo. Las luces traseras conectadas cierran
                                    una silueta sólida y moderna, pensada para destacar
                                    en cualquier entorno.
                                    Cada línea suma fuerza. Cada detalle eleva el estilo.
                                    Este SUV combina robustez y sofisticación con una claridad:
                                    está hecho para quienes no siguen el camino, lo definen.
                                </p>
                                <Image src={CretaExtBanner} alt="Creta Exterior" fluid />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="pt-3 pt-md-5">
                        <Col md={4}>
                            <Image src={CretaExt1} alt="Creta Exterior 1" fluid />
                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Llantas de Aleación de 17”.
                            </p>
                        </Col>
                        <Col md={4}>
                            <Image src={CretaExt2} alt="Creta Exterior 2" fluid />
                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Parrilla Paramétrica.
                            </p>
                        </Col>
                        <Col md={4}>
                            <Image src={CretaExt3} alt="Creta Exterior 3" fluid />
                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Faros delanteros LED.
                            </p>
                        </Col>
                    </Row>
                    <Row className="pt-2 pt-md-3">
                        <Col md={4}>
                            <Image src={CretaExt4} alt="Creta Exterior 4" fluid />
                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Antena de radio tipo tiburón.
                            </p>
                        </Col>
                        <Col md={4}>
                            <Image src={CretaExt5} alt="Creta Exterior 5" fluid />

                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Faros posteriores LED.
                            </p>
                        </Col>
                        <Col md={4}>
                            <Image src={CretaExt6} alt="Creta Exterior 6" fluid />
                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Rieles de carga en el techo.
                            </p>
                        </Col>
                    </Row>
                </Container>
                {/*<Container>
                    <Row className="py-3 py-md-5">
                        <Col md={12} className="text-center">
                            <h2 className="specs-subtitle mt-4 pb-3 px-3 px-md-0">
                                Una experiencia deportiva y tecnológica por dentro y por fuera
                            </h2>
                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Conducción suave y el manejo refinado de un sedán conservando
                                todas las ventajas de un SUV. Un sub-bastidor súper rígido
                                proporciona a CRETA una base sólida para anclar los componentes
                                de suspensión y dirección. La arquitectura de la suspensión
                                garantiza una conducción cómoda, estable y precisa. La geometría
                                del amortiguador posterior está más cerca de la posición
                                vertical, lo que crea una relación de apalancamiento más alta
                                que absorve los golpes de manera efectiva.
                            </p>
                            <Image src={Experiencia} alt="Creta Experiencia" fluid />
                        </Col>
                    </Row>
                </Container>*/}
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={12} className="text-center">
                                <h2 className="specs-subtitle mt-4 pb-3 px-3 px-md-0">
                                    Estilo interior
                                </h2>
                                <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                    Todo en el interior del Nuevo Creta está diseñado para una experiencia
                                    de conducción llena de confort. La pantalla táctil de 9”, integrada
                                    al tablero digital, crea un ambiente lleno de conectividad.
                                    Los asientos, el espacio y los acabados refuerzan la sensación de amplitud.
                                    Aquí solo existe lo esencial, para que tomes el control con comodidad, estilo y total claridad de a dónde quieres llegar.
                                </p>
                                <Image src={Interior} alt="Creta Interior" fluid />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <Row className="pt-3 pt-md-5">
                        <Col md={4}>
                            <Image src={CretaInt1} alt="Creta Interior 1" fluid />
                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Pantalla táctil de 9" con Apple CarPlay/Android Auto.
                            </p>
                        </Col>
                        <Col md={4}>
                            <Image src={CretaInt2} alt="Creta Interior 2" fluid />
                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Asiento regulable manualmente en altura (conductor).
                            </p>
                        </Col>
                        <Col md={4}>
                            <Image src={CretaInt3} alt="Creta Interior 3" fluid />
                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Asientos (2da fila) plegables 6:4.
                            </p>
                        </Col>
                    </Row>
                    <Row className="pt-2 pt-md-3">
                        <Col md={4}>
                            <Image src={CretaInt4} alt="Creta Interior 4" fluid />
                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Volante de 4 ejes forrado en cuero.
                            </p>
                        </Col>
                        <Col md={4}>
                            <Image src={CretaInt5} alt="Creta Interior 5" fluid />

                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Lámpara de maletero.
                            </p>
                        </Col>
                        <Col md={4}>
                            <Image src={CretaInt6} alt="Creta Interior 6" fluid />
                            <p className="specs-text mt-2 pb-md-4 px-3 px-md-0">
                                Visor de sol (Conductor y pasajero).
                            </p>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <h4
                                    onClick={() => onChangeMenu("calidad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Calidad de tiempo
                                </h4>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <h4
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    Rendimiento
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </h4>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** rendimiento ***************************************/}
            <section id="rendimiento" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">TU CAMINO, TUS REGLAS</h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                El Nuevo Creta está hecho para acompañarte con rendimiento en
                                cada trayecto. Responde cuando lo necesitas y se mantiene
                                fuerte en los caminos más exigentes.
                                Gracias a sus modos de manejo y a una conducción precisa,
                                moverse con el Creta se siente natural. Sentir que tú decides
                                el ritmo, el terreno y el momento. Porque tomar el control también
                                es avanzar sin sacrificar comodidad ni eficiencia.
                            </p>
                        </Col>
                    </Row>
                    <Row className="my-md-4">
                        <Col md={4} className="mt-3 mt-md-4">
                            <Image src={Motor} alt="Creta Motor" fluid />
                            <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                Motor Smartstream 1.5L, 114 hp y 144 Nm de torque.
                            </h3>
                        </Col>
                        <Col md={4} className="mt-3 mt-md-4">
                            <Image src={ModoConduccion} alt="Modo conduccion" fluid />
                            <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                Modos de conducción.
                            </h3>
                        </Col>
                        <Col md={4} className="mt-3 mt-md-4">
                            <Image src={Manual} alt="Creta Manual" fluid />
                            <h3 className="specs-subtitle-sm mt-3 px-3 px-md-0">
                                Palanca manual de 6 velocidades.
                            </h3>
                        </Col>
                    </Row>
                </Container>
                {/*<div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col md={6} className="mt-4">
                                <Image
                                    src={SuspensionDelantera}
                                    alt="Creta Suspension Delantera"
                                    fluid
                                />
                                <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                    Suspensión delantera MacPherson Strut
                                </h3>
                            </Col>
                            <Col md={6} className="mt-4">
                                <Image
                                    src={SuspensionPosterior}
                                    alt="Creta Suspension Posterior"
                                    fluid
                                />
                                <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                    Suspensión posterior , eje con brazo de torsión
                                </h3>
                            </Col>
                        </Row>
                    </Container>
                </div>*/}
                <Container>
                    <Row className="py-3 py-md-5">
                        <Col md={12} className="text-center">
                            <Image
                                src={RendimientoBanner}
                                alt="Creta Rendimiento"
                                fluid
                                className="w-100"
                            />
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <h4
                                    onClick={() => onChangeMenu("disenio")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Diseño
                                </h4>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <h4
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    Seguridad
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </h4>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** seguridad ***************************************/}
            <section id="seguridad" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title px-3 px-md-0">
                                CONFIANZA QUE TE ACOMPAÑA
                            </h2>
                            <p className="model-text mb-md-5 mt-3 px-3 px-md-0">
                                El Nuevo Creta  está equipado para darte seguridad
                                en cada momento del trayecto. Con tecnologías de asistencia
                                al conductor y un sistema de protección integral, te permite
                                moverte con tranquilidad tanto en ciudad como en carretera.
                                Desde la detección de punto ciego hasta el frenado autónomo,
                                cada función trabaja en segundo plano para que tomes el control
                                con confianza, sabiendo que estás respaldado en cada maniobra.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="pt-3 pt-md-5">
                            <Col md={12} className="text-center">
                                <h3 className="specs-subtitle my-3 px-3 px-md-0">
                                    Especificaciones
                                </h3>
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-5">
                            <Col md={4} className="mt-4">
                                <Image src={Seguridad1} alt="Seguridad 2" fluid />
                                <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                    6 Airbags.
                                </h3>
                            </Col>
                            <Col md={4} className="mt-4">
                                <Image src={Seguridad2} alt="Segurad 2" fluid />
                                <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                    Asistente de arranque en pendiente (H.A.C.).
                                </h3>
                            </Col>
                            <Col md={4} className="mt-4">
                                <Image src={Seguridad3} alt="Segurad 3" fluid />
                                <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                    Control electrónico de estabilidad (E.S.C.)
                                </h3>
                            </Col>
                        </Row>
                        <Row className="pb-3 pb-md-5">
                            <Col md={2}></Col>
                            <Col md={4} className="mt-4">
                                <Image src={Seguridad4} alt="Segurad 4" fluid />
                                <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                    Sistema antibloqueo de frenos (A.B.S.)
                                </h3>
                            </Col>
                            <Col md={4} className="mt-4">
                                <Image src={Seguridad5} alt="Seguridad 5" fluid />
                                <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                    Distribución electrónica de frenado (E.B.D)
                                </h3>
                            </Col>
                            <Col md={2}></Col>
                        </Row>
                        <Row>
                            <Col md={12} className="py-3 px-md-0">
                                <Image src={Seguridad6} alt="Creta Seguridad 6" fluid />
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <h4
                                    onClick={() => onChangeMenu("rendimiento")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Rendimiento
                                </h4>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                                <h4
                                    onClick={() => onChangeMenu("conveniencia")}
                                    className="titulo-navegacion"
                                >
                                    Conveniencia
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </h4>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** conveniencia ***************************************/}
            <section id="conveniencia" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">
                                TECNOLOGÍA QUE SE MUEVE CONTIGO
                            </h2>
                            <p className="model-text mb-md-3 mt-3 px-3 px-md-0">
                                El Nuevo Creta está pensado para hacer todo más fácil. 
                                Su interior combina funcionalidad, conectividad y diseño 
                                intuitivo, para que cada trayecto fluya desde el primer momento.
                                Desde el primer contacto con la llave, todo fluye: espacios 
                                funcionales, ductos de ventilación para los pasajeros traseros y 
                                detalles que suman comodidad sin complicaciones.
                                Porque tomar el control también es tener todo donde lo necesitas, 
                                cuando lo necesitas.
                            </p>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    {/*<Container>
                        <Row className="py-3 py-md-5">
                            <Col md={12} className="px-md-0 text-center">
                                <Image src={Versatil} alt="Creta Versatil" fluid />
                            </Col>
                        </Row>
                    </Container>*/}
                </div>
                <Container>
                    <Row className="py-3 py-md-5">
                        <Col md={4} className="mt-4">
                            <Image src={Conveniencia1} alt="Conveniencia 1" fluid />
                            <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                Cámara de reversa.
                            </h3>
                            {/*<p className="specs-text px-3 px-md-0">
                                Los vidrios eléctricos son equipo estándar pero para una medida
                                adicional de seguridad y conveniencia la ventana del conductor
                                incluye el sistema automático arriba/ abajo y función
                                anti-pellizco.
                            </p>*/}
                        </Col>
                        <Col md={4} className="mt-4">
                            <Image src={Conveniencia3} alt="Conveniencia 3" fluid />
                            <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                Tablero de instrumentos digital con computadora de viaje.
                            </h3>
                        </Col>
                        <Col md={4} className="mt-4">
                            <Image src={Conveniencia2} alt="Conveniencia 2" fluid />
                            <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                Bluetooth con reconocimiento de voz.
                            </h3>
                        </Col>
                    </Row>
                    <Row className="py-3 py-md-5">
                        <Col md={4} className="mt-4">
                            <Image src={Conveniencia4} alt="Conveniencia 4" fluid />
                            <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                Control de audio en el volante 
                            </h3>
                        </Col>
                        <Col md={4} className="mt-4">
                            <Image src={Conveniencia5} alt="Conveniencia 5" fluid />
                            <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                Luces automáticas.
                            </h3>
                        </Col>
                        <Col md={4} className="mt-4">
                            <Image src={Conveniencia6} alt="Conveniencia 6" fluid />
                            <h3 className="specs-subtitle-sm mt-4 pt-2 px-3 px-md-0">
                                Puertos USB tipo c.
                            </h3>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <h4
                                    onClick={() => onChangeMenu("seguridad")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Seguridad
                                </h4>
                            </Col>
                            <Col xs={6} md={6}></Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </Fragment>
    );
}
export default InfoNuevoCreta;